/* eslint-disable */
/*!
* @scbd/locale 0.0.10
*
* @link www.cbd.int
* @source https://github.com/scbd/ecosystem/packages/locale
* @copyright (c) 2019-2020 Secretariat of the Convention on Biological Diversity <it@cbd.int>
* @license MIT
* https://github.com/scbd/ecosystem/blob/master/LICENCE
*/

const unLocales = [ 'ar', 'en', 'es', 'fr', 'ru', 'zh' ];

const unLocalesSet = new Set(unLocales);

const scbdCMSLocale = () => {
  if(typeof window === 'undefined') return ''

  const pref = window.document.cookie.replace(/(?:(?:^|.*;\s*)Preferences\s*=\s*([^;]*).*$)|^.*$/, '$1');

  if(pref) return (pref.replace('Locale=', ''))

  return ''
};

const html5Locale = () => {
  if(typeof window === 'undefined') return ''

  const htmlEl = document.querySelector('html');

  if(!htmlEl) return ''

  return htmlEl.getAttribute('lang') || ''
};

const legacyHtmlLocale = () => {
  if(typeof window === 'undefined' || typeof document === 'undefined') return ''

  const metaEl = document.querySelector('meta[http-equiv=content-language]');
  
  if(!metaEl) return ''
  return metaEl.getAttribute('content') || ''
};

const legacyBrowserLocale = () => {
  if(typeof navigator === 'undefined') return ''
  return (navigator.languages && navigator.languages.length) ? navigator.languages[0] : navigator.userLanguage || navigator.language || navigator.browserLanguage || ''
};

const browserLocale = () => {
  if(typeof Intl === 'undefined') return ''
  return (new Intl.NumberFormat())? (new Intl.NumberFormat()).resolvedOptions().locale : ''
};

const get = () => {
  const locale = scbdCMSLocale() || html5Locale()|| legacyHtmlLocale() || legacyBrowserLocale() || browserLocale();

  return locale? locale.toLowerCase().slice(0, 2) : 'en'
};

const getUN = () => {
  const locale = get();

  for (const lang of unLocales)
    if(locale.includes(lang))
      return lang

  return 'en'
};

const getUnLocale = getUN;

export { browserLocale, get, getUN, getUnLocale, html5Locale, legacyBrowserLocale, legacyHtmlLocale, scbdCMSLocale, unLocalesSet };
//# sourceMappingURL=index.js.map
